import React from 'react'

function Clock() {
  return (
    <div>Clock</div>
  )
}

export default Clock